import React from 'react';
import { Link } from 'react-scroll';
import { Typography, createTheme, ThemeProvider } from '@mui/material';

const footerTheme = (darkMode) => createTheme({
  palette: {
    mode: darkMode ? 'dark' : 'light',
    text: {
      primary: darkMode ? '#fff' : 'rgba(0, 0, 0, 0.87)',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        body2: {
          color: darkMode ? '#fff' : 'rgba(0, 0, 0, 0.87)',
        },
      },
    },
  },
});

const Footer = ({ darkMode }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={`footer`}>
      <p>
        <ThemeProvider theme={footerTheme(darkMode)}>
        <Typography variant="body2" className='footer-text'>
          &copy; {currentYear}{' '}
          <Link to="hero-section" offset={-100} smooth={true} duration={500}>
            <span className='footer-span'>Sahib Sidhu</span>
          </Link>
          </Typography>
          
        </ThemeProvider>
      </p>
    </div>
  );
};

export default Footer;
